
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';
import { DeleteConfirmationDialog } from './DeleteConfirmationDialog';
import { useSoftDelete, EntityType } from '@/hooks/useDeletion';

interface DeleteButtonProps {
  entityType: EntityType;
  entityId: string;
  entityName: string;
  onDeleted?: () => void;
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
  children?: React.ReactNode;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  entityType,
  entityId,
  entityName,
  onDeleted,
  variant = 'destructive',
  size = 'default',
  className,
  children
}) => {
  const [showDialog, setShowDialog] = useState(false);
  const deleteMutation = useSoftDelete();

  const handleDelete = (reason?: string) => {
    deleteMutation.mutate(
      { entityType, entityId, reason },
      {
        onSuccess: (data) => {
          if (data.success) {
            setShowDialog(false);
            onDeleted?.();
          }
        }
      }
    );
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={() => setShowDialog(true)}
        className={className}
      >
        {children || (
          <>
            <Trash2 className="h-4 w-4 mr-2" />
            Delete
          </>
        )}
      </Button>

      <DeleteConfirmationDialog
        isOpen={showDialog}
        onOpenChange={setShowDialog}
        onConfirm={handleDelete}
        entityType={entityType}
        entityName={entityName}
        isLoading={deleteMutation.isPending}
      />
    </>
  );
};
